export default __webpack_public_path__ + "static/media/calendar.c5d0e45e.png";